import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, Loading } from 'ionic-angular';
import { AwsProvider } from '../../providers/aws/aws';
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  userData: object;

  constructor(public navCtrl: NavController, public navParams: NavParams, public aws: AwsProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController) {
    this.userData = { username: '', password: '' };
  }

  logIn(): void {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    this.aws.signIn(this.userData['username'], this.userData['password'])
      .then((result) => {
        if (result['success']) {
          this.navCtrl.setRoot(HomePage);
        } else {
          let alert = this.alertCtrl.create({
            message: result['message'],
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
        loading.dismiss();
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts